import { Box, TextField, Typography } from '@mui/material';

export default function EditableField({ label, value, multiline = false, isEditable }) {
    if (isEditable) {
        return (
            <TextField
                variant="standard"
                label={label}
                value={value}
                multiline={multiline}
            />
        );
    }

    return (
        <Box>
            <Typography
                variant="caption"
                color="text.secondary"
                display="block"
            >
                {label}
            </Typography>

            <Typography
                variant="subtitle1"
                fontWeight={600}
                sx={{ wordBreak: 'break-word' }}
            >
                {value}
            </Typography>
        </Box>
    );
}
